import { useEffect } from "react";
import { MapContainer, Marker, TileLayer, ZoomControl, useMap, useMapEvents } from "react-leaflet";
import tokens from "@/theme/tokens";
import { PIN_ICONS } from "@/components/map/pins";

const CARTO_KEY = process.env.REACT_APP_CARTO_API_KEY;

export function DarkTiles() {
  if (CARTO_KEY)
    return <TileLayer url={tokens.map.cartoTiles + CARTO_KEY} attribution={tokens.map.cartoAttribution} subdomains="abcd" maxZoom={19} />;
  return <TileLayer url={tokens.map.osmTiles} attribution={tokens.map.osmAttribution} className="lux-dark-tiles" maxZoom={19} />;
}

export function FitView({ points, animate = true }) {
  const map = useMap();
  const signature = JSON.stringify(points);
  useEffect(() => {
    if (points.length === 1) map.setView(points[0], 14, { animate });
    else if (points.length > 1) map.fitBounds(points, { padding: [48, 48], animate });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature]);
  return null;
}

function ClickToPin({ onPick }) {
  useMapEvents({ click: (e) => onPick(e.latlng) });
  return null;
}

export function PinMap({ pickup, dropoff, active, onPick, showDropoff }) {
  const locations = { pickup, dropoff: showDropoff ? dropoff : null };
  const points = Object.values(locations).filter(Boolean).map((p) => [p.lat, p.lng]);
  return (
    <div className="relative h-64 overflow-hidden rounded-2xl border border-line sm:h-80" data-testid="booking-map">
      <MapContainer center={tokens.map.center} zoom={tokens.map.zoom} zoomControl={false} className="h-full w-full">
        <DarkTiles />
        <ZoomControl position="bottomright" />
        <ClickToPin onPick={(latlng) => onPick(latlng, active)} />
        <FitView points={points} />
        {Object.entries(locations).map(([kind, loc]) =>
          loc ? (
            <Marker
              key={kind}
              position={[loc.lat, loc.lng]}
              icon={PIN_ICONS[kind]}
              draggable
              eventHandlers={{ dragend: (e) => onPick(e.target.getLatLng(), kind) }}
            />
          ) : null,
        )}
      </MapContainer>
      <div className="glass pointer-events-none absolute left-3 top-3 z-[500] rounded-full px-3 py-1.5 text-[11px] text-mist" data-testid="map-hint">
        Tap the map or drag a pin to set your <span className="text-gold">{active === "pickup" ? "pickup" : "drop-off"}</span>
      </div>
    </div>
  );
}
